import React from 'react'
import classnames from 'classnames'
import { useQuery } from '@apollo/react-hooks'
import { NavLink, useParams, generatePath } from 'react-router-dom'
import { GetLabOrderHistoryByTestReference } from '../../../graphql/lab-orders/queries.js'

import { Chart } from '../ResultDetails/HistoryChart/Chart'
import { Chartv2 } from '../ResultDetails/HistoryChart/Chartv2'
import { LAB_REPORTS } from '../../../config/routes'
import style from './LabReportTrendChild.module.css'

const MARGINS = 20

export default function LabReportTrendChild({ editing, test, width }) {
  const { labReportId } = useParams()

  const { data } = useQuery(GetLabOrderHistoryByTestReference, {
    skip: !test || !test.reference.id,
    variables: {
      labOrderId: labReportId,
      testReferenceId: test && test.reference.id,
    },
  })

  const charting = data?.getLabOrderHistoryByTestReference

  return (
    <NavLink
      data-test="link-result"
      to={
        (!editing &&
          generatePath(LAB_REPORTS.resultDetails, {
            labReportId,
            resultId: test.id,
          })) ||
        undefined
      }
      className={classnames(style.container, {
        [style.statusAbnormal]: test.status === 'abnormal',
        [style.statusBorderline]: test.status === 'borderline',
        [style.editing]: editing,
      })}
    >
      <Chartv2 data={charting?.results} ranges={charting?.ranges} />
    </NavLink>
  )
}
